/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：865
 */

var r = require(/* 1433 */"./1433/index")
var i = require(/* 2543 */"./2543/index")
var o = require(/* 771 */"../../../../../797/101/2466/2477/2536/771/index")
module.exports = function (e) {
  return o(e) ? r(e, true) : i(e)
}
